import IconButton from '@mui/material/IconButton';
import { useDispatch, useSelector } from 'react-redux';
import { selectWdCurrentSettings, setDefaultSettings } from 'app/store/core/settingsSlice';
import _ from 'lodash';
import useThemeMediaQuery from '@main/hooks/useThemeMediaQuery';
import { navbarToggle, navbarToggleMobile } from 'app/store/core/navbarSlice';
import WdSvgIcon from '@main/core/WdSvgIcon';
import { Tooltip } from '@mui/material';

function NavbarToggleButton(props) {
  const dispatch = useDispatch();
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));
  const settings = useSelector(selectWdCurrentSettings);
  const { config } = settings.layout;

  return (
    <Tooltip
      title={
        props?.open
          ? 'Presiona para cerrar la barra de navegación'
          : 'Presiona para abrir la barra de navegación'
      }
      placement="bottom"
    >
      <IconButton
        className={props.className}
        color="inherit"
        size="small"
        onClick={(ev) => {
          if (isMobile) {
            dispatch(navbarToggleMobile());
          } else if (config.navbar.style === 'style-2') {
            dispatch(
              setDefaultSettings(
                _.set({}, 'layout.config.navbar.folded', !settings.layout.config.navbar.folded)
              )
            );
          } else {
            dispatch(navbarToggle());
          }
        }}
      >
        {props.children}
      </IconButton>
    </Tooltip>
  );
}

NavbarToggleButton.defaultProps = {
  children: (
    <WdSvgIcon size={20} color="action">
      material-solid:menu
    </WdSvgIcon>
  ),
};

export default NavbarToggleButton;
